import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    header_title: ''
};

export const updatePageHeaderSlice = createSlice({
    name: "updatePageHeader",
    initialState,
    reducers: {
        updateTitle: (state, action) => {
            state.header_title = action.payload
        }
    }
})



export const { updateTitle } = updatePageHeaderSlice.actions

export default updatePageHeaderSlice.reducer